export function setStatusFormAlert( data, typeAlertToSet, setFormRequestStatus, timeToRemoveMessage) {
  let messagerWaning = data.message;

  setFormRequestStatus({
    typeAlert: typeAlertToSet,
    message: messagerWaning,
  });

  let millisecondsToClose = messagerWaning.length * 100;
  let timeClockToClose = new Date().getTime() + messagerWaning.length * 75;

  timeToRemoveMessage.current = timeClockToClose;
  setTimeout(() => {
    let milliseconds = new Date().getTime();

    if (milliseconds >= timeToRemoveMessage.current) {
      setFormRequestStatus({
        typeAlert: "",
        message: "",
      });
    }
  }, millisecondsToClose);
}
